export default {
  client: "Client",
  operation: " Operation",
};
